module.exports = __webpack_public_path__ + "img/ring_r_e_null_1.b8dcf393.png";